import {
  apisSchema,
  databaseSchema,
  webSchema,
  serverSchema,
  cloudSchema,
  otherSchemaObj,
  apisSchemaEdit,
  databaseSchemaEdit,
  webSchemaEdit,
  serverSchemaEdit,
  cloudSchemaEdit,
} from "../Validation/PasswordValidation";

export const newDateChanger = (date) => {
  const today = new Date(date);
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();
  let hr = today.getHours();
  let min = today.getMinutes();
  let ampm = hr < 12 ? "AM" : "PM";
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  if (hr > 12) hr = hr - 12;
  if (hr < 10) hr = "0" + hr;
  if (min < 10) min = "0" + min;
  const formattedToday =
    dd + "-" + mm + "-" + yyyy + " " + hr + ":" + min + " " + ampm;
  return formattedToday;
};
export const LOGIN_DATA = JSON.parse(
  localStorage.getItem("loggedInUser")
);

export const formatDate = (dateString) => {
  const date = new Date(dateString); // Create a Date object from the date string
  const isoDate = date.toISOString().split("T")[0]; // Convert to ISO string and extract the date part
  return isoDate;
};

export const validationSchema = (type, details, isEdit) => {
  if (type === "APIs") {
    return {
      schma: isEdit ? apisSchemaEdit : apisSchema,
      initial: {
        passwordType: isEdit ? details.passwordType : type,
        identifier: isEdit ? details.identifier : "",
        platform: isEdit ? details.platform : "",
        apiKey: isEdit ? details.apiKey : "",
        apiSecret: isEdit ? "**********" : "",
        folderId: isEdit ? details.folderId : "",
        envId: isEdit ? details.envId : "",
        note: isEdit ? details.note : "",
        pwExpiryDate: isEdit ? details?.pwExpiryDate || "" : "",
        filename: isEdit ? details.filename : "",
        // secretFile: "",
      },
    };
  }
  if (type === "Database Access") {
    return {
      schma: isEdit ? databaseSchemaEdit : databaseSchema,
      initial: {
        passwordType: isEdit ? details.passwordType : type,
        username: isEdit ? details.username : "",
        identifier: isEdit ? details.identifier : "",
        platform: isEdit ? details.platform : "",
        password: isEdit ? "**********" : "",
        port: isEdit ? details.port : "",
        dbconnectionStrings: isEdit
          ? details.dbconnectionStrings
          : "",
        folderId: isEdit ? details?.folderId : "",
        envId: isEdit ? details.envId : "",
        pwExpiryDate: isEdit ? details?.pwExpiryDate || "" : "",
        note: isEdit ? details?.note : "",
      },
    };
  }
  if (type === "Web Applications") {
    return {
      schma: isEdit ? webSchemaEdit : webSchema,
      initial: {
        passwordType: isEdit ? details.passwordType : type,
        username: isEdit ? details.username : "",
        identifier: isEdit ? details.identifier : "",
        platform: isEdit ? details.platform : "",
        password: isEdit ? "**********" : "",
        folderId: isEdit ? details.folderId : "",
        envId: isEdit ? details.envId : "",
        pwExpiryDate: isEdit ? details?.pwExpiryDate || "" : "",
        note: isEdit ? details.note : "",
      },
    };
  }
  if (type === "Server Access") {
    return {
      schma: isEdit ? serverSchemaEdit : serverSchema,
      initial: {
        passwordType: isEdit ? details.passwordType : type,
        username: isEdit ? details.username : "",
        identifier: isEdit ? details.identifier : "",
        platform: isEdit ? details.platform : "",
        password: isEdit ? "**********" : "",
        port: isEdit ? details.port : "",
        folderId: isEdit ? details.folderId : "",
        envId: isEdit ? details.envId : "",
        pwExpiryDate: isEdit ? details?.pwExpiryDate || "" : "",
        note: isEdit ? details.note : "",
      },
    };
  }
  if (type === "Cloud Services") {
    return {
      schma: isEdit ? cloudSchemaEdit : cloudSchema,
      initial: {
        passwordType: isEdit ? details.passwordType : type,
        username: isEdit ? details.username : "",
        identifier: isEdit ? details.identifier : "",
        platform: isEdit ? details.platform : "",
        password: isEdit ? "**********" : "",
        folderId: isEdit ? details.folderId : "",
        envId: isEdit ? details.envId : "",
        note: isEdit ? details.note : "",
        pwExpiryDate: isEdit ? details?.pwExpiryDate || "" : "",
        filename: isEdit ? details.filename : "",
        // secretFile: "",
      },
    };
  }
  if (type === "Others") {
    return {
      schma: otherSchemaObj,
      initial: {
        passwordType: isEdit ? details.passwordType : type,
        identifier: isEdit ? details.identifier : "",
        platform: "",
        folderId: isEdit ? details.folderId : "",
        envId: isEdit ? details.envId : "",
        note: isEdit ? details.note : "",
        pwExpiryDate: isEdit ? details?.pwExpiryDate || "" : "",
        other: isEdit ? details.other : "",
      },
    };
  }
};

export const types = {
  upperCase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
  lowerCase: "abcdefghijklmnopqrstuvwxyz",
  numbers: "0123456789",
  symbols: "!@#$%^&*()_+~`|}{[]:;?><,./-=",
};

// Function to randomly select an uppercase letters
export function upperCase() {
  return types.upperCase[
    Math.floor(Math.random() * types.upperCase.length)
  ];
}

// Function to randomly select an lowercase letters
export function lowerCase() {
  return types.lowerCase[
    Math.floor(Math.random() * types.lowerCase.length)
  ];
}

// Function to randomly select a number
export function numbers() {
  return types.numbers[
    Math.floor(Math.random() * types.numbers.length)
  ];
}

// Function to randomly select a symbol
export function symbols() {
  return types.symbols[
    Math.floor(Math.random() * types.symbols.length)
  ];
}
export const getType = [
  "numbers",
  "upperCase",
  "symbols",
  "lowerCase",
];
